export const HOME_ROUTE_KEY = 'aquaFarina_homeRoute';
